var map = {
	"./0.png": 56760,
	"./1.svg": 92687,
	"./11.svg": 56012,
	"./13.svg": 6606,
	"./20.svg": 15556,
	"./3.svg": 84285,
	"./4.svg": 50354,
	"./5.svg": 88291,
	"./6.svg": 43152,
	"./7.svg": 55393,
	"./8.svg": 32598,
	"./9.svg": 19719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59990;